"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useOrderAndSplitPaymentMethodsByGEO = function (paymentSettings, country) {
    var splitMethods = (0, react_1.useCallback)(function (methods) {
        if (!methods)
            return [];
        var splitMethods = [];
        methods.forEach(function (method) {
            var _a, _b;
            var splitConfig = paymentSettings.splittedMethods;
            if ((method === null || method === void 0 ? void 0 : method.slug) && ((_a = splitConfig === null || splitConfig === void 0 ? void 0 : splitConfig[country]) === null || _a === void 0 ? void 0 : _a[method === null || method === void 0 ? void 0 : method.slug])) {
                var splitMethodConfig = (_b = splitConfig === null || splitConfig === void 0 ? void 0 : splitConfig[country]) === null || _b === void 0 ? void 0 : _b[method === null || method === void 0 ? void 0 : method.slug];
                splitMethodConfig.forEach(function (item) {
                    var newMethod = __assign(__assign({}, method), { images: { logo: null }, name: '', childMethodId: item });
                    splitMethods.push(newMethod);
                });
            }
            else
                splitMethods.push(method);
        });
        return splitMethods;
    }, [paymentSettings, country]);
    return (0, react_1.useCallback)(function (methods) {
        var splitedMethods = splitMethods(methods);
        var methodsWithSettings = [];
        var methodsWithoutSettings = [];
        splitedMethods.forEach(function (method) {
            var _a;
            var methodId = method['childMethodId']
                ? method['childMethodId']
                : method.slug;
            var methodConfig = (_a = paymentSettings === null || paymentSettings === void 0 ? void 0 : paymentSettings.methods) === null || _a === void 0 ? void 0 : _a[String(methodId)];
            if (methodConfig && methodConfig['order'])
                methodsWithSettings.push(__assign(__assign({}, method), { settings: methodConfig }));
            else
                methodsWithoutSettings.push(method);
        });
        var orderedMethods = methodsWithSettings.sort(function (a, b) {
            var _a, _b, _c, _d;
            return ((((_b = (_a = a === null || a === void 0 ? void 0 : a['settings']) === null || _a === void 0 ? void 0 : _a['order']) === null || _b === void 0 ? void 0 : _b[country]) || 1000000) -
                (((_d = (_c = b === null || b === void 0 ? void 0 : b['settings']) === null || _c === void 0 ? void 0 : _c['order']) === null || _d === void 0 ? void 0 : _d[country]) || 1000000));
        });
        return {
            withSetup: orderedMethods,
            additional: methodsWithoutSettings,
        };
    }, [paymentSettings, country, splitMethods]);
};
exports.default = useOrderAndSplitPaymentMethodsByGEO;
